const apiAddressConst = "https://widget.datablocks.se/api/rose"; 
const apiCustomerIdConst = "c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";

const apiTokenConstDashboard = "d1919941-a906-4a4b-8ab1-6f5b24c158aa&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";

const apiTokenConst = "d15a9880-b604-42d6-8f81-5379791e0ac4&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07&load-highcharts=true";

const apiTokenConstDonut = "276a7941-6545-470e-8f0b-cda8d5f25d88&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07&load-highcharts=true";

const apiTokenConstTableQuarter = "6daf7a47-c11c-43bd-8ec5-3ec7963deaf6&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";

const apiTokenConstTableYear = "59a242d6-7b18-4bc7-83c1-4ea3a5f6fb71&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";

const apiTokenConstEBIT = "a30e9309-e7e9-44bd-880a-cd283f3461e2&c=c77dd5d1-dfa4-4e34-8cd5-c2c3c1599f07";

function modifyFetchedChart(widget) {
  if (widget == 'kpi-graph')
  if ($('#kpi-graph path.highcharts-point').length > 0) {
    $('#kpi-graph path.highcharts-point').attr('fill','rgb(14,16,63)');
  }

  if (widget == 'kpi-tableyear') {
    removeDomain();
  }

  return true;
}

function removeDomain() {
    $('.nav-item .nav-link').each(function(){
      let href = $(this).attr('href');
      let ind_of_hash = href.indexOf('#');
      if (ind_of_hash == -1) return true;
      let setting = href.substring(ind_of_hash,href.length);
      $(this).attr('href',setting);
    });
}

function setupObserver() {
  let observer = new MutationObserver(mutationRecords => {
    modifyFetchedChart();
    observer.disconnect();
  });

  $( document ).ready(function() { 
    observer.observe($("#kpi-tablequarter")[0], {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });  
    removeDomain();
  });
}

function modifyFetchedChart() {

  var tableWidth = $('#kpi-tablequarter thead th').length;

  console.log(tableWidth);
  
  $('#kpi-tablequarter thead th').each(function(i){
    console.log(i);
    if (i > 0 && i < tableWidth - 8)
      $(this).hide();
  });

  $('#kpi-tablequarter tbody tr').each(function(i){
    $(this).find('td').each(function(i){
      console.log(i);
      if (i > 0 && i < tableWidth - 8)
        $(this).hide();
    });
  });
}

function setupChart(apiToken,apiCustomerId,apiAddress,widget,forcedTableName=null) {
  var locale = Shopify.locale;
  (function(widgets) {
    var url = apiAddressConst;
    if (!window._MF) {
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = url + "/assets/js/loader-v4.js";
        document.getElementsByTagName("body")[0].appendChild(b);
    }
    window._MF = window._MF || {
        data: [],
        url: url,
        ready: !!0,
        render: function() { window._MF.ready = !0 },
        push: function(w) { window._MF.data.push(w) }
    };	
    window._MF.push(widgets);
  })([{
    query:"#" + (forcedTableName?forcedTableName:widget)
  ,callback:  false //function() { modifyFetchedChart(widget); }
  ,className: widget + " list-comp one show"
  ,customerId: apiCustomerId
  ,demo: false
  ,locale: locale
  ,token: apiToken
  ,widget: widget
  } 
  ],
  );
}

setupObserver();
setupChart(apiTokenConstDashboard,apiCustomerIdConst,apiAddressConst,"kpi-dashboard");
setupChart(apiTokenConstDonut,apiCustomerIdConst,apiAddressConst,"kpi-donut");
setupChart(apiTokenConst,apiCustomerIdConst,apiAddressConst,"kpi-graph");
setupChart(apiTokenConstTableQuarter,apiCustomerIdConst,apiAddressConst,"kpi-table-v2","kpi-tablequarter");
setupChart(apiTokenConstTableYear,apiCustomerIdConst,apiAddressConst,"kpi-table-v2","kpi-tableyear");
setupChart(apiTokenConstEBIT,apiCustomerIdConst,apiAddressConst,"kpi-graph","kpi-ebit");

